import { Overlay, OverlayContainer, PositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { InjectionToken, Injector } from '@angular/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalOverlayRef } from './modal-overlay-ref';

export const MODAL_DATA = new InjectionToken<any>('MODAL_DATA');

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private overlay: Overlay, private injector: Injector, private overlayContainer: OverlayContainer) {}

  public open(component, data?, options?: { panelClass?: string | string[] }): Observable<any> {
    const panelClass = options?.panelClass ?? 'modal-panel';
    const overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'modal-backdrop',
      panelClass,
      positionStrategy: this.createPositionStrategy(),
    });
    const modalRef = new ModalOverlayRef(overlayRef);
    const injector = this.createInjector(modalRef, data);
    const portal = new ComponentPortal(component, null, injector);
    overlayRef.attach(portal);
    const overlayContainerElement = this.overlayContainer.getContainerElement();
    overlayContainerElement.setAttribute('data-ctx', 'overlay-container');
    return modalRef.afterClosed();
  }

  private createInjector(dialogRef, data): Injector {
    return Injector.create({
      parent: this.injector,
      providers: [
        { provide: ModalOverlayRef, useValue: dialogRef },
        { provide: MODAL_DATA, useValue: data }
      ]
    });
  }

  private createPositionStrategy(): PositionStrategy {
    return this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();
  }
}
